import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { GetProjectPaymentScheduleQuery } from '@/gql/graphql';
import { useQuery } from '@tanstack/react-query';
import projectKeys from './keyFactory';

const GetProjectPaymentSchedule = graphql(`
  query GetProjectPaymentSchedule($projectId: ID!) {
    projectById(id: $projectId) {
      id
      paymentSchedule {
        stages {
          stage {
            ...DerivedPaymentStageFields
          }
          invoice {
            ...InvoiceFields
          }
          invoiceValue {
            value
            currency {
              id
              code
              exponent
            }
          }
          invoiceProjectPercentage
        }
        explainer
        isInSync
      }
    }
  }
`);

export type ProjectPaymentScheduleStages = NonNullable<
  GetProjectPaymentScheduleQuery['projectById']['paymentSchedule']
>['stages'];

export type ProjectPaymentScheduleStage = ProjectPaymentScheduleStages[number];

export const isGrantRow = ({ stage, invoice }: ProjectPaymentScheduleStage) =>
  stage ? stage.__typename === 'DerivedGrantStage' : !!invoice?.isGrantInvoice;

export const getRowGrantLine = ({
  stage,
  invoice,
}: ProjectPaymentScheduleStage) =>
  stage?.__typename === 'DerivedGrantStage'
    ? stage.grantLine
    : invoice?.grantLine;

export const useGetProjectPaymentSchedule = (projectId?: string) => {
  return useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.paymentSchedule(projectId!),
    queryFn: async () => {
      const data = await gqlClient.request<GetProjectPaymentScheduleQuery>(
        GetProjectPaymentSchedule,
        {
          projectId: projectId,
        }
      );
      return data.projectById?.paymentSchedule ?? null;
    },
  });
};
